<template>
  <div class="rounded p-2">
    <div class="rounded p-3">
      <div class="row">
        <div class="col-12 col-md-4 pt-2">
          <div class="regular text-gray">
            Fecha de comienzo:
          </div>
          <span v-if="model.assignmentStartDate" class="regular">
            {{ formatter(model.assignmentStartDate) | date }}
          </span>
          <span v-if="!model.assignmentStartDate" class="regular">
            -
          </span>
        </div>

        <div class="col-12 col-md-4 pt-2">
          <div class="regular text-gray">
            Proveedor:
          </div>
          <span
            class="regular"
            v-text="
              (model.assignedProvider && model.assignedProvider.name) || '-'
            "
          />
        </div>

        <div class="col-12 col-md-4 pt-2">
          <div class="regular text-gray">
            Lugar de Servicio:
          </div>
          <span
            class="regular"
            v-text="(model.placement && model.placement.name) || '-'"
          />
        </div>

        <div class="col-12 col-md-4 pt-2">
          <div class="regular text-gray">
            Maestro:
          </div>
          <span
            class="regular"
            v-text="(model.teacher && model.teacher.name) || '-'"
          />
        </div>

        <div class="col-12 col-md-4 pt-2">
          <div class="regular text-gray">
            Asistente de Servicio:
          </div>
          <span
            class="regular"
            v-text="(model.assistant && model.assistant.name) || '-'"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'TeacherAssignment',
  props: {
    existingData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    model() {
      return this.existingData;
    },
  },
  methods: {
    formatter(date) {
      return (date && moment(date)) || '-';
    },
  },
};
</script>
